export function getCssCustomProperty(propertyName: string) {
  return getComputedStyle(document.documentElement).getPropertyValue(`--${propertyName}`)
}
